<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <div class="mb-5">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    v-model="fields.settings.backgroundColor"
                  />
                  <v-text-field v-model="fields.settings.backgroundColor" hide-details class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    v-model="fields.settings.textColor"
                  />
                  <v-text-field v-model="fields.settings.textColor" hide-details class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.settings.paddingTop" label="Top Padding" hide-details class="mt-0" />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.settings.paddingBottom" label="Bottom Padding" hide-details class="mt-0" />
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox
                  v-model="fields.containerPage.enableStyle"
                  label="Enable Style Container"
                  hide-details
                  class="mt-0 mb-2"
                />
                <div v-if="fields.containerPage.enableStyle">
                  <label>Container Background</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      v-model="fields.containerPage.background"
                    />
                    <v-text-field v-model="fields.containerPage.background" hide-details class="mt-0" />
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Title Section</label>
          <div class="group-item">
            <v-checkbox v-model="fields.titleCard.show" label="Show title block" hide-details class="mt-0 mb-2" />
            <ckeditor
              v-if="fields.titleCard.show"
              :editor="editor"
              v-model="fields.titleCard.content"
              :config="editorConfig"
            />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Card Items</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <label>Column Per View</label>
                <v-select v-model="fields.listItem.colPerView" :items="[1, 2, 3, 4, 5, 6]" hide-details class="mt-0" />
              </v-col>
              <v-col cols="12" md="4">
                <label>Space Between (px)</label>
                <v-text-field v-model.number="fields.listItem.spaceBetween" type="number" hide-details class="mt-0" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.listItem.sttShow" label="Show STT badge" hide-details class="mt-4" />
              </v-col>
              <v-col cols="12" md="6" v-if="fields.listItem.sttShow">
                <label>STT Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    v-model="fields.listItem.sttBackground"
                  />
                  <v-text-field v-model="fields.listItem.sttBackground" hide-details class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6" v-if="fields.listItem.sttShow">
                <label>STT Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    v-model="fields.listItem.sttColor"
                  />
                  <v-text-field v-model="fields.listItem.sttColor" hide-details class="mt-0" />
                </div>
              </v-col>
            </v-row>

            <div class="d-flex justify-end mb-2">
              <v-btn small color="primary" @click="handleAddCardItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.listItem.items" :key="`card-${i}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveCardItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-4">
                    <UploadImage
                      @callback="obj => handleUploadCardImage(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`180`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveCardImage(i)"
                    />
                  </div>
                  <div class="mb-4">
                    <label>STT Label</label>
                    <v-text-field v-model="item.stt" hide-details class="mt-0" />
                  </div>
                  <div class="mb-4">
                    <label>Text Content</label>
                    <ckeditor :editor="editor" v-model="item.text" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Button</label>
          <div class="group-item">
            <v-checkbox v-model="fields.button.show" label="Show button" hide-details class="mt-0 mb-2" />
            <template v-if="fields.button.show">
              <v-row>
                <v-col cols="12" md="6">
                  <label>Text</label>
                  <v-text-field v-model="fields.button.text" hide-details class="mt-0" />
                </v-col>
                <v-col cols="12" md="6">
                  <label>Link</label>
                  <v-text-field v-model="fields.button.link" hide-details class="mt-0" />
                </v-col>
                <v-col cols="12" md="6">
                  <label>Background</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      v-model="fields.button.background"
                    />
                    <v-text-field v-model="fields.button.background" hide-details class="mt-0" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <label>Text Color</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      v-model="fields.button.color"
                    />
                    <v-text-field v-model="fields.button.color" hide-details class="mt-0" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <label>Border Radius (px)</label>
                  <v-text-field v-model.number="fields.button.radius" type="number" hide-details class="mt-0" />
                </v-col>
              </v-row>
            </template>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Policy Items</label>
          <div class="group-item">
            <v-checkbox v-model="fields.policy.show" label="Show policy block" hide-details class="mt-0 mb-2" />
            <template v-if="fields.policy.show">
              <!-- <v-row>
                <v-col cols="12" md="6">
                  <label>Column Per View</label>
                  <v-select v-model="fields.policy.colPerView" :items="[1, 2, 3, 4]" hide-details class="mt-0" />
                </v-col>
              </v-row> -->
              <div class="d-flex justify-end mb-2">
                <v-btn small color="primary" @click="handleAddPolicyItem">
                  <v-icon size="16">mdi-plus</v-icon>
                  <span>Add Policy</span>
                </v-btn>
              </div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, i) in fields.policy.items" :key="`policy-${i}`">
                  <v-expansion-panel-header>
                    <div class="d-flex justify-space-between align-center">
                      <span>Policy {{ i + 1 }}</span>
                      <v-btn icon @click.stop="handleRemovePolicyItem(i)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="mb-4">
                      <UploadImage
                        @callback="obj => handleUploadPolicyIcon(obj, i)"
                        :image="{ imageSrc: item.icon }"
                        :height="`120`"
                        :typeUpload="'image'"
                        @callbackDelete="handleRemovePolicyIcon(i)"
                      />
                    </div>
                    <div class="mb-4">
                      <label>Text</label>
                      <v-text-field v-model="item.text" hide-details class="mt-0" />
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </template>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';

const getDefaultFields = () => ({
  title: 'Card Grid Boxer Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  titleCard: {
    show: true,
    content:
      "<h2>4 Reasons Why</h2><h3>TitanBoxers Aren't Like Any Boxer You've Worn Before</h3><p>If you've spent years settling for standard cotton or struggling with bulky \"medical\" solutions, your first day in an ICEMAX boxer will be a revelation.</p>",
  },
  listItem: {
    colPerView: 4,
    spaceBetween: 30,
    sttShow: true,
    sttBackground: '#606f99',
    sttColor: '#FFFFFF',
    items: [{ image: '', stt: '1', text: '<h2></h2><p></p>' }],
  },
  button: {
    show: true,
    text: 'TRY IT TODAY, RISK-FREE !',
    link: '#',
    background: '#606f99',
    color: '#FFFFFF',
    radius: 6,
  },
  policy: {
    show: true,
    colPerView: 2,
    items: [{ icon: '', text: '' }],
  },
});

export default {
  name: 'CardGridBoxerSectionEditor',
  components: { UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      titleCard: { ...def.titleCard, ...(extract.titleCard || {}) },
      listItem: {
        ...def.listItem,
        ...(extract.listItem || {}),
        items:
          extract.listItem && extract.listItem.items && extract.listItem.items.length
            ? extract.listItem.items.map(item => ({
                image: item.image || '',
                stt: item.stt || '',
                text: item.text || '',
              }))
            : def.listItem.items,
      },
      button: { ...def.button, ...(extract.button || {}) },
      policy: {
        ...def.policy,
        ...(extract.policy || {}),
        items:
          extract.policy && extract.policy.items && extract.policy.items.length
            ? extract.policy.items.map(item => ({
                icon: item.icon || '',
                text: item.text || '',
              }))
            : def.policy.items,
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardGridBoxer(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadCardImage(obj, index) {
      this.fields.listItem.items[index].image = obj.imageSrc;
    },
    handleRemoveCardImage(index) {
      this.fields.listItem.items[index].image = '';
    },
    handleAddCardItem() {
      this.fields.listItem.items.push({
        image: '',
        stt: String(this.fields.listItem.items.length + 1),
        text: '<h2></h2><p></p>',
      });
    },
    handleRemoveCardItem(index) {
      if (this.fields.listItem.items.length <= 1) return;
      this.fields.listItem.items.splice(index, 1);
    },
    handleUploadPolicyIcon(obj, index) {
      this.fields.policy.items[index].icon = obj.imageSrc;
    },
    handleRemovePolicyIcon(index) {
      this.fields.policy.items[index].icon = '';
    },
    handleAddPolicyItem() {
      this.fields.policy.items.push({ icon: '', text: '' });
    },
    handleRemovePolicyItem(index) {
      if (this.fields.policy.items.length <= 1) return;
      this.fields.policy.items.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline,
.ck-editor__editable {
  min-height: 180px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
